import React from 'react'
import Link from 'gatsby-link'

import Header from '../components/Header/header'

import nano from '../images/covers/nano.jpg';
import NewsPreview from '../components/NewsPreview/news-preview';
import Research from '../components/Research/research';
import Publication from '../components/Publication/publication';
import Collaborator from '../components/Collaborator/collaborator';

import SeeMore from '../components/SeeMore/see-more';

export default ({ data }) => {


  let researchAreas = [];
  data.allContentfulResearchAreas.edges.map(( { node } ) => {
    researchAreas.push(node);
  });

  let research = researchAreas.map((research, index) => {
    return <Research key={research.id} title={research.topic} image={research.image.file.url} first={index % 3 === 0} link={'/research/' + research.slug}/>
  });

  let latestNews = [];
  data.allContentfulNews.edges.map(( { node } ) => {
    latestNews.push(node);
  });

  let newsPreviews = latestNews.map((news, index) => {
    return <NewsPreview key={news.id} title={news.title} image={news.image.file.url} description={news.description.description} first={index % 2 === 0} link={'/news/' + news.slug}/>
  });

  let sponsors = [];

  // collaborators
  data.allContentfulCollaborators.edges.map(( { node } ) => {
    if (!node.sponsor) {
      sponsors.push(node)
    }
  });

  let sponsorImages = sponsors.map((sponsor, index) => {
    return <Collaborator name={sponsor.name} logo={sponsor.logo.file.url} url={sponsor.link}/>
  });

  return (
    <div>
      <Header
        image={nano}
        title={"NANOTECH LAB | YUSHIN GROUP"}
        subtitle={"Transforming the energy materials landscape from the nanoscale to the macro"}
      />
      <section className={"about-blurb"}>
        <div className={"container"}>
          <div className="row">
            <p className="col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10">
                Our research group focuses on finding nanotechnology-driven solutions to enable the next generation of
                lighter, more energy dense, more cost effective energy storage devices by studying their materials
                structure-property relationships. We have developed nano-scale synthesis strategies to bypass
                macro-scale limitations of energy and structural materials with applications in clean tech, electric
                vehicles, wearable electronics, and more.
            </p>
          </div>
        </div>
      </section>
      <section className={"grey news"}>
        <div className={"container"}>
          <div className="row">
            <h2 className="col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10">News</h2>
          </div>
          <div className="row">
            { newsPreviews }
          </div>
          <SeeMore link={"/news"} content={"See all News"}/>
        </div>
      </section>
      <section className={"research"}>
        <div className={"container"}>
          <div className="row">
            <h2 className="col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10">Research Areas</h2>
          </div>
          <div className="row">
            {research}
          </div>
        </div>
      </section>
      <section className={"grey publications"}>
        <div className={"container"}>
          <div className="row">
            <h2 className="col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10">Publications</h2>
          </div>
          <div className="row">
            {
              data.allContentfulPublication.edges.map(( { node } ) => {
                return <Publication key={node.id} title={node.title} journal={node.journal} authors={node.authors} year={node.year} abstract={node.description.description} link={node.url}/>
              })
            }
          </div>

          <SeeMore link={"/publications"} content={"See all Publications"}/>

        </div>
      </section>
      <section className={"collaborators"}>
        <div className={"container"}>
          <div className="row">
            <h2 className="col-xs-12 col-sm-12 col-lg-offset-1 col-lg-11 col-xl-10">Collaborators</h2>
          </div>
          <div className="row">
          <div className={"collaboration col-xs-12 col-sm-12 col-md-12 col-lg-offset-1 col-lg-10 col-xl-10"}>
            <p>
              Some of the Institutions we’ve collaborated in the past. For collaboration inquiries, contact Professor Gleb Yushin.
            </p>
          </div>
          {sponsorImages}
          </div>
          <SeeMore link={"/collaborators"} content={"See all Collaborators"}/>
        </div>
      </section>
      <section className={"grey contact-us"}>
        <div className={"container"}>
          <div className="row">
            <h2 className="col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10">Contact Us</h2>
          </div>
          <div className="row">
            <p className={"col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10"}>Get in touch! Send an email to Professor Yushin at <a href="maito:yushin@gatech.edu">yushin@gatech.edu</a>.</p>
          </div>
        </div>
      </section>
    </div>


  )

}

export const query = graphql`
  query IndexQuery {
    allContentfulResearchAreas{
      edges {
        node {
          id
          topic
          slug
          description{
            id
            description
          }
          image {
            id
            file {
              url
              fileName
              contentType
            }
          }
        }
      }
    }
    allContentfulNews (sort: {fields: [createdAt], order:DESC}, limit: 4){
      edges {
        node {
          id
          title
          slug
          createdAt
          description {
            id
            description
          }
          content {
            id
            content
          }
          image {
            id
            file {
              url
              fileName
              contentType
            }
          }
        }
      }
    }
    allContentfulPublication (sort: {fields: [year], order:DESC}, limit: 4){
      edges{
        node {
            id
            title
            journal
            year
            authors
            description {
              id
              description
            }
            url
        }
      }
    }
    allContentfulCollaborators(sort:{fields: [sponsor], order:ASC}, limit: 4) {
      edges {
        node {
          id
          name
          sponsor
          link
          logo {
            id
            file {
              url
              fileName
              contentType
            }
          }
        }
      }
    }
  }
`;




// WEBPACK FOOTER //
// ./src/pages/index.js